import { useEffect, useState } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import order from "../../component/img/order.png";
import DataTable from "react-data-table-component";

function UserAllOrderAdmin() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    // Dummy Order Data
    const dummyOrders = [
      {
        id: 1,
        order_no: "ORD12345",
        order_date: "2024-02-10",
        seller_name: "ABC Electronics",
        product_name: "Smartphone X",
        order_type: "Online",
      },
      {
        id: 2,
        order_no: "ORD12346",
        order_date: "2024-02-09",
        seller_name: "XYZ Gadgets",
        product_name: "Wireless Earbuds",
        order_type: "COD",
      },
      {
        id: 3,
        order_no: "ORD12347",
        order_date: "2024-02-08",
        seller_name: "Tech World",
        product_name: "Laptop Pro",
        order_type: "Online",
      },
      {
        id: 4,
        order_no: "ORD12348",
        order_date: "2024-02-07",
        seller_name: "Gadget Hub",
        product_name: "Smart Watch",
        order_type: "Prepaid",
      },
    ];

    setOrders(dummyOrders);
  }, []);

  // Define Columns for DataTable
  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "80px",
    },
    {
      name: "Order No",
      selector: (row) => row.order_no,
      sortable: true,
    },
    {
      name: "Order Date",
      selector: (row) => new Date(row.order_date).toLocaleDateString(),
      sortable: true,
    },
    {
      name: "To Seller",
      selector: (row) => row.seller_name,
      sortable: true,
    },
    {
      name: "Product Name",
      selector: (row) => row.product_name,
      sortable: true,
    },
    {
      name: "Order Type",
      selector: (row) => row.order_type,
      sortable: true,
    },
  ];

  return (
    <>
      <div>
        <AdminTopbar />
        <div className="crdmain1">
          <div className="container-fluid">
            {/* Order History Section */}
            <div className="mb-2">
              <div className="row g-2 mt-0 mb-0 bg-white">
                <div className="d-flex justify-content-between align-items-center">
                  <h2 className="chart-title text-start">
                    Order History : User Name
                  </h2>
                </div>

                <div className="col-md-2 mb-2">
                  <div className="d-flex justify-content-around align-items-center p-3 text-start quick-button-small">
                    <div className="ag4">
                      <span className="agsvg1 p-2">
                        <img src={order} className="img-fluid" alt="Order" />
                      </span>
                    </div>
                    <div>
                      <span className="ag22 font4">{orders.length}</span> Total Orders
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* DataTable for Orders */}
            <div className="mb-2">
              <div className="row g-2 mt-0 mb-0 bg-white">
                <div className="d-flex justify-content-between align-items-center">
                  <h2 className="chart-title text-start">All Orders</h2>
                </div>

                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={orders}
                    pagination
                    highlightOnHover
                    striped
                    noDataComponent="No Orders Found"
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default UserAllOrderAdmin;
